<template>
  <div class="template-connected">
    <div id="container" class="no-padding">
      <div class="notfound">
        <div class="page-content">
          <div class="page-single-content">
            <b-img
              src="../img/404.png"
              class="img-login"
              alt="Page non trouver"
            ></b-img>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "404",
};
</script>

<style></style>
